module.exports = __webpack_public_path__ + "img/17.2c455101.jpg";